"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statistics = void 0;
exports.statistics = function (axios) {
    return {
        getStatisticsSalesProduct: function (request) {
            return axios.get('/statistics/sales/product', request);
        },
        getStatisticsSalesProductSummary: function (request) {
            return axios.get('/statistics/sales/product/summary', request);
        },
        getStatisticsSalesCategory: function (request) {
            return axios.get('/statistics/sales/category', request);
        },
        getStatisticsSalesCategorySummary: function (request) {
            return axios.get('/statistics/sales/category/summary', request);
        },
        getStatisticsPromotionsCartCoupons: function (request) {
            return axios.get('/statistics/promotions/cart-coupons', request);
        },
        getStatisticsPromotionsProductCoupons: function (request) {
            return axios.get('/statistics/promotions/product-coupons', request);
        },
        getStatisticsPromotionsCartCouponsSummary: function (request) {
            return axios.get('/statistics/promotions/cart-coupons/summary', request);
        },
        getStatisticsPromotionsProductCouponsSummary: function (request) {
            return axios.get('/statistics/promotions/product-coupons/summary', request);
        },
        getStatisticsSalesPeriod: function (request) {
            return axios.get('/statistics/sales/period', request);
        },
        getStatisticsSalesPeriodSummary: function (request) {
            return axios.get('/statistics/sales/period/summary', request);
        },
        getStatisticsPromotionsAdditionalDiscount: function (request) {
            return axios.get('/statistics/promotions/additional-discount', request);
        },
        getStatisticsPromotionsAdditionalDiscountSummary: function (request) {
            return axios.get('/statistics/promotions/additional-discount/summary', request);
        },
        getStatisticsMemberTypes: function (request) {
            return axios.get('/statistics/member-types', request);
        }
    };
};
